export default () => ({
  currentPodcast: null,
  currentEpisode: null,
  currentEpisodeId: null,
  chapters: [],
  transcript: [],
  currentTime: null,
  skipTo: null,
  countdown: '',
  status: 'stopped',
  playlist: [],
  tooltipsId: [],
  loading: false,
  volume: 1
})
